/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import LinkedShapesListItem from "App/render/webgl/utils/linked_shapes_list_item";
import RenderObject from "App/geometry/objects/object";

export class LinkedShapesList {
    private _first: LinkedShapesListItem = null;
    private _last: LinkedShapesListItem = null;
    private _objects: any[] = [];

    constructor() {
    }

    public push(aObject: any) {
        if (this._last === null) {
            this._last = aObject.getPlacement();
            this._first = this._last;

            this._objects.push(aObject);

            return;
        }

        let newItem = aObject.getPlacement();
        this._last.setAnc(newItem);
        newItem.setPred(this._last);
        newItem.setAnc(null);

        this._last = newItem;

        this._objects.push(aObject);
    }

    public getObjectsArray(): any {
        return this._objects;
    }

    public remove(aItem) {
        if (aItem._pred === null) {
            this._first = aItem._anc;
        } else {
            aItem._pred._anc = aItem._anc;
        }

        if (aItem._anc === null) {
            this._last = aItem._pred;
        } else {
            aItem._anc._pred = aItem._pred;
        }

        let removedObjectUID = aItem.getObject().getUID();
        for (let i = 0; i < this._objects.length; i++) {
            if (this._objects[i].getUID() === removedObjectUID) {
                this._objects.splice(i, 1);
                return;
            }
        }
    }

    public first(): LinkedShapesListItem {
        return this._first;
    }

    public last(): LinkedShapesListItem {
        return this._last;
    }

    public find(aShapeUID: number): LinkedShapesListItem {
        let item = this._first;
        while (item) {
            if (item.getObject().getUID() === aShapeUID) {
                return item;
            }

            item = item.getAnc();
        }

        return null;
    }

    public isEmpty() {
        return this._first === null;
    }

    public resetPlacement() {
        let item = this._first;
        while (item) {
            item.resetPlacement();
            item = item.getAnc();
        }
    }
}